/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon16Solid = forwardRef('MediaAudioMicAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3Z" }),
        React.createElement("path", { d: "M3.25 5.875c.483 0 .875.392.875.875V8a3.875 3.875 0 0 0 7.75 0V6.75a.875.875 0 0 1 1.75 0V8a5.626 5.626 0 0 1-4.75 5.557v.688H10.5a.875.875 0 0 1 0 1.75h-5a.875.875 0 0 1 0-1.75h1.625v-.688A5.626 5.626 0 0 1 2.375 8V6.75c0-.483.392-.875.875-.875Z" })));
});
